import { ANNOUNCEMENT_EVENTS } from '@moal/api'
import { useContext, useEffect, useState } from 'react'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { SocketContext } from '../../../context/socketContext'
import { PRODUCT_CODE } from '../../../utils/ENV'
import { NotificationBadge } from '../NotificationBadge'

const UnreadCountBadge = () => {
  const { latestAnnouncement, loadLatestAnnouncement } =
    useContext(SiteConfigContext)
  const { announcementsSocket } = useContext(SocketContext)
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    if (announcementsSocket) {
      announcementsSocket.on(ANNOUNCEMENT_EVENTS.POST, addAnnouncement)
      announcementsSocket.on(ANNOUNCEMENT_EVENTS.EDIT, editAnnouncement)
      announcementsSocket.on(ANNOUNCEMENT_EVENTS.DELETE, deleteAnnouncement)
      announcementsSocket.on(ANNOUNCEMENT_EVENTS.READ, editAnnouncement)
      announcementsSocket.on(ANNOUNCEMENT_EVENTS.READ_ALL, resetCount)
    }

    return () => {
      if (announcementsSocket) {
        announcementsSocket.off(ANNOUNCEMENT_EVENTS.POST, addAnnouncement)
        announcementsSocket.off(ANNOUNCEMENT_EVENTS.EDIT, editAnnouncement)
        announcementsSocket.off(ANNOUNCEMENT_EVENTS.DELETE, deleteAnnouncement)
        announcementsSocket.off(ANNOUNCEMENT_EVENTS.READ, editAnnouncement)
        announcementsSocket.off(ANNOUNCEMENT_EVENTS.READ_ALL, resetCount)
      }
    }
  }, [announcementsSocket])

  useEffect(() => {
    if (latestAnnouncement && !latestAnnouncement.read) {
      setUnreadCount(1)
    } else {
      setUnreadCount(0)
    }
  }, [latestAnnouncement])

  const resetCount = () => {
    setUnreadCount(0)
  }

  const addAnnouncement = (data) => {
    if (data.itemNumber !== PRODUCT_CODE) {
      return
    }
    // Announcement is for this product
    setUnreadCount(1)
  }

  const editAnnouncement = (data) => {
    if (
      data.itemNumber !== PRODUCT_CODE ||
      data._id !== latestAnnouncement._id
    ) {
      return
    }
    // Announcement is for this product and this is the latest announcement
    if (data.read) {
      setUnreadCount(0)
    } else {
      setUnreadCount(1)
    }
  }

  const deleteAnnouncement = (data) => {
    if (
      data.itemNumber !== PRODUCT_CODE ||
      data._id !== latestAnnouncement._id
    ) {
      return
    }
    // Announcement is for this product and this is the latest announcement
    // We should fetch the next latest announcement
    loadLatestAnnouncement()
  }

  return <NotificationBadge count={unreadCount} />
}

export default UnreadCountBadge
